import { render, staticRenderFns } from "./TreatmentPicker.vue?vue&type=template&id=5df8e1ee&scoped=true"
import script from "./TreatmentPicker.vue?vue&type=script&lang=js"
export * from "./TreatmentPicker.vue?vue&type=script&lang=js"
import style0 from "./TreatmentPicker.vue?vue&type=style&index=0&id=5df8e1ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df8e1ee",
  null
  
)

export default component.exports